import { render } from "./ValueTypeSelect.vue?vue&type=template&id=bb73b970"
import script from "./ValueTypeSelect.vue?vue&type=script&lang=js"
export * from "./ValueTypeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__